import React, {FC, useMemo} from 'react';
import {useQueryResponseData, useQueryResponseLoading} from "../../Elemnt/PostCategory_list/core/QueryResponseProvider";
import ElementListSearchComponent from "../../Elemnt/PostCategory_list/components/header/ElementListSearchComponent";


import ElementListPagination from "../../Elemnt/PostCategory_list/components/pagination/ElementListPagination";
import {ID, toAbsoluteUrl} from "../../../../_metronic/helpers";
import {useListView} from "../../Elemnt/PostCategory_list/core/ListViewProvider";
import ElementItemsSelect from "./ElementItemsSelect";

type prop = {
    onsubmit : (ID:ID)=>void,

}

const ElementModalSelect : FC<prop> = ({onsubmit}) => {
    const users = useQueryResponseData()
    const isLoading = useQueryResponseLoading()
    const data = useMemo(() => users, [users])
    const {selected,clearSelected} = useListView()

    return (
        <div className="col-md-12">
            <div><ElementListSearchComponent/></div>
            <div className="row  p-2">
                {data.length > 0 ? (
                    data.map((row , i) => (
                        <ElementItemsSelect  data={row} key={i} />
                    ))
                ) : (
                    <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                        No matching records found
                    </div>
                )}
            </div>
            <ElementListPagination />
            <div className="p-2">
                <button onClick={()=> {
                    onsubmit(selected[0])
                    clearSelected()
                }} className="btn btn-info">تایید</button>
            </div>
        </div>
    );
};

export default ElementModalSelect;